export { default } from './OutlineCard';
